// Vietnamese translation for financial module
export default {
  'center': {
    'common': {
      'search': 'Tìm kiếm',
      'reset': 'Đặt lại',
      'submit': 'Gửi',
      'cancel': 'Hủy',
      'confirm': 'Xác nhận',
      'operation': 'Thao tác',
      'status': 'Trạng thái',
      'createTime': 'Thời gian tạo',
      'updateTime': 'Thời gian cập nhật',
      'remark': 'Ghi chú',
      'amount': 'Số tiền',
      'currency': 'Tiền tệ',
      'orderNumber': 'Số đơn hàng',
      'memberAccount': 'Tài khoản thành viên',
      'fee': 'Phí',
      'type': 'Loại',
      'all': 'Tất cả',
      'pending': 'Đang chờ',
      'processing': 'Đang xử lý',
      'completed': 'Hoàn thành',
      'failed': 'Thất bại',
      'rejected': 'Từ chối',
      'approved': 'Đã phê duyệt',
      'locked': 'Đã khóa',
      'unlocked': 'Đã mở khóa',
      'dateRange': 'Khoảng thời gian',
      'startDate': 'Ngày bắt đầu',
      'endDate': 'Ngày kết thúc',
      'dateType': 'Loại ngày',
      'dateType.createTime': 'Thời gian tạo',
      'dateType.updateTime': 'Thời gian cập nhật',
      'dateType.completeTime': 'Thời gian hoàn thành',
      'dateType.applyTime': 'Thời gian nộp',
      'dateType.successTime': 'Thời gian hoàn thành',
      'noData': 'Không có dữ liệu',
      'startAmount': 'Số tiền tối thiểu',
      'endAmount': 'Số tiền tối đa'
    },
    'withdrawal': {
      'title': 'Quản lý đơn rút tiền',
      'config': {
        'title': 'Cấu hình rút tiền',
        'basic': {
          'title': 'Cấu hình cơ bản rút tiền',
          'minAmount': 'Số tiền rút tối thiểu',
          'maxAmount': 'Số tiền rút tối đa',
          'dailyLimit': 'Giới hạn rút tiền hàng ngày',
          'monthlyLimit': 'Giới hạn rút tiền hàng tháng',
          'feeRate': 'Tỷ lệ phí',
          'feeType': 'Loại phí',
          'feeTypes': {
            'fixed': 'Số tiền cố định',
            'percentage': 'Phần trăm'
          }
        },
        'risk': {
          'title': 'Cấu hình kiểm soát rủi ro',
          'ipLimit': 'Giới hạn IP',
          'deviceLimit': 'Giới hạn thiết bị',
          'locationLimit': 'Giới hạn vị trí',
          'riskLevel': 'Mức độ rủi ro',
          'riskLevels': {
            'low': 'Thấp',
            'medium': 'Trung bình',
            'high': 'Cao'
          }
        }
      },
      'order': {
        'title': 'Đơn rút tiền',
        'status': {
          'pending': 'Chờ xem xét',
          'processing': 'Đang xử lý',
          'completed': 'Hoàn thành',
          'failed': 'Thất bại',
          'rejected': 'Đã từ chối',
          'waiting': 'Chờ thanh toán',
          'paid': 'Đã thanh toán',
          'dfProcessing': 'Đang xử lý thanh toán',
          'locked': 'Thanh toán bị khóa',
          'riskLocked': 'Đã khóa đang xem xét'
        },
        'type': {
          'bank': 'Chuyển khoản ngân hàng',
          'crypto': 'Tiền điện tử',
          'other': 'Khác',
          'BANK': 'Thẻ ngân hàng',
          'ALIPAY': 'Alipay',
          'WECHAT': 'WeChat',
          'USDT': 'USDT'
        },
        'action': {
          'approve': 'Phê duyệt',
          'reject': 'Từ chối',
          'lock': 'Khóa',
          'unlock': 'Mở khóa',
          'detail': 'Chi tiết',
          'confirm': 'Xác nhận thanh toán',
          'paid': 'Xử lý thanh toán',
          'rejectWithdraw': 'Từ chối rút tiền',
          'frontRemark': 'Ghi chú giao diện',
          'backRemark': 'Ghi chú hậu trường',
          'dfFailReason': 'Lý do thất bại đại phó',
          'updateChannel': 'Cập nhật kênh thanh toán',
          'adminUnlock': 'Quản trị viên mở khóa'
        },
        'info': {
          'orderNumber': 'Số đơn hàng',
          'memberAccount': 'Tài khoản thành viên',
          'currency': 'Tiền tệ rút',
          'amount': 'Thông tin số tiền',
          'withdrawAmount': 'Số tiền rút',
          'fee': 'Phí',
          'realAmount': 'Số tiền thực tế',
          'withdrawMethod': 'Phương thức rút tiền',
          'operationInfo': 'Thông tin hoạt động',
          'applyTime': 'Thời gian nộp',
          'riskCheckTime': 'Thời gian kiểm tra rủi ro',
          'riskCheckOperator': 'Người kiểm tra rủi ro',
          'successTime': 'Thời gian thanh toán',
          'successOperator': 'Người thanh toán',
          'channelName': 'Kênh thanh toán',
          'refuseTime': 'Thời gian từ chối',
          'refuseOperator': 'Người từ chối',
          'timeProgress': 'Tiến trình thời gian rút tiền',
          'status': 'Trạng thái',
          'remark': 'Ghi chú',
          'manualOperation': 'Rút tiền thủ công',
          'withdrawShowInfo':'Thông tin rút tiền',
          'showInfoBankAccount':'Tên tài khoản thẻ ngân hàng',
          'showInfoBankNumber':'Số thẻ ngân hàng',
          'showInfoBankName':'Tên thẻ ngân hàng',
          'showInfoUSDTAccount':'Địa chỉ USDT',
          'showInfoUSDTRate':'Tỷ giá hối đoái USDT',
          'showInfoUSDTType':'Loại chuỗi USDT',
          'showInfoRealName':'Tên',
          'showInfoAccount':'Tài khoản',
          'showInfoRealAmount':'Số tiền thanh toán',
          'showInfoCurSign':'Tiền tệ',
          'clickCreateOrderTime': 'Thành viên nhấp rút tiền',
          'receiveServerTime': 'Máy chủ nhận yêu cầu',
          'financialOperatorTime': 'Kế toán xử lý rút tiền',
          'externalReceiveTime': 'Hoàn tất callback bên thứ ba',
          'systemGeneratedOrder': 'Hệ thống tạo đơn hàng',
        },
        'modal': {
          'reject': {
            'title': 'Từ chối rút tiền',
            'frontRemark': 'Ghi chú giao diện',
            'backRemark': 'Ghi chú hậu trường',
            'confirm': 'Xác nhận',
            'cancel': 'Hủy',
            'success': 'Từ chối thành công',
            'failed': 'Từ chối thất bại'
          },
          'confirm': {
            'title': 'Xác nhận thanh toán',
            'content': 'Bạn có chắc chắn muốn xác nhận thanh toán không?',
            'confirm': 'Xác nhận',
            'cancel': 'Hủy',
            'success': 'Xác nhận thanh toán thành công',
            'failed': 'Xác nhận thanh toán thất bại',
            '70016015': 'Số tiền không đạt đến số tiền tối thiểu của kênh',
            '70016016': 'Số lượng vượt quá số lượng tối đa của kênh',
            '70018018':'Cấu hình tham số kênh không bình thường, vui lòng kiểm tra',
            '70015065':'Việc thanh toán cho lệnh rút tiền này không thành công. Vui lòng thử các kênh thanh toán khác',
            '70015073':'Bản ghi này đang được xử lý, vui lòng không lặp lại thao tác này',
            '70015017':'Thanh toán thay mặt thành viên yêu cầu xác minh tên thật',
            '70015076': 'Vui lòng kiểm tra trạng thái đơn hàng mới nhất',
          },
          'paid': {
            'title': 'Xử lý thanh toán',
            'channel': 'Kênh thanh toán',
            'selectChannel': 'Vui lòng chọn kênh thanh toán',
            'confirm': 'Xác nhận',
            'cancel': 'Hủy',
            'success': 'Xử lý thanh toán thành công',
            'failed': 'Xử lý thanh toán thất bại'
          },
          'remark': {
            'title': 'Thông tin ghi chú',
            'frontRemark': 'Ghi chú giao diện',
            'backRemark': 'Ghi chú hậu trường',
            'close': 'Đóng'
          },
          'updateChannel': {
            'title': 'Cập nhật kênh thanh toán',
            'channel': 'Kênh thanh toán',
            'selectChannel': 'Vui lòng chọn kênh thanh toán',
            'confirm': 'Xác nhận',
            'cancel': 'Hủy',
            'success': 'Cập nhật kênh thanh toán thành công',
            'failed': 'Cập nhật kênh thanh toán thất bại'
          }
        }
      }
    },
    'recharge': {
      'title': 'Quản lý đơn nạp tiền',
      'config': {
        'title': 'Cấu hình nạp tiền',
        'channel': {
          'title': 'Cấu hình kênh nạp tiền',
          'name': 'Tên kênh',
          'currency': 'Loại tiền tệ',
          'platform': 'Loại nền tảng',
          'status': 'Trạng thái',
          'statuses': {
            'enabled': 'Bật',
            'disabled': 'Tắt'
          }
        }
      },
      'order': {
        'title': 'Đơn nạp tiền',
        'info': {
          'orderNumber': 'Số đơn hàng',
          'memberAccount': 'Tài khoản thành viên',
          'paymentChanneName':'Tên kênh',
          'currency': 'Tiền tệ',
          'amount': 'Số tiền',
          'fee': 'Phí',
          'realAmount': 'Số tiền thực tế',
          'status': 'Trạng thái đơn hàng',
          'createTime': 'Thời gian tạo',
          'payTime': 'Thời gian thanh toán',
          'orderSource': 'Nguồn đơn hàng',
          'platform': 'Nền tảng',
          'dateType': 'Loại ngày',
          'dateRange': 'Khoảng thời gian',
          'startDate': 'Ngày bắt đầu',
          'endDate': 'Ngày kết thúc',
          'paymentMethod': 'Phương thức thanh toán',
          'successTime': 'Thời gian thành công',
          'successOperator':'Người điều hành',
          'timeInfo': 'Thông tin thời gian',
          'showOvertimeOnly': 'Chỉ hiển thị đơn hàng quá thời gian',
          'memberOrderTime': 'Thời gian đặt hàng của thành viên',
          'paymentSuccessTime': 'Thời gian thanh toán thành công',
          'timeDetails': {
            't0': 'T0 Nhấp đặt hàng',
            't1': 'T1 Yêu cầu đặt hàng',
            't2': 'T2 Tạo đơn hàng',
            't3': 'T3 Bên thứ ba trả về',
            't3_5': 'T3.5 Trả về frontend',
            't4': 'T4 Chuyển đến thanh toán',
            't5': 'T5 Phản hồi callback',
            'memberPaying': '🟢 Thành viên đang thanh toán',
            'paymentTimeout': '🔴 Liên kết thanh toán hết thời gian: T3.5-T0 = {time}',
            'expandFullLink': 'Mở rộng liên kết đầy đủ',
            'collapseFullLink': 'Thu gọn liên kết đầy đủ'
          },
        },
        'source': {
          'H5': 'H5',
          'IOS': 'IOS',
          'ANDROID': 'ANDROID'
        },
        'status': {
          'pending': 'Đang chờ',
          'processing': 'Đang xử lý',
          'completed': 'Hoàn thành',
          'failed': 'Thất bại',
          'rejected': 'Đã từ chối',
          'waiting': 'Đang chờ',
          'paid': 'Đã thanh toán',
          'dfProcessing': 'Đang xử lý thanh toán',
          'locked': 'Đã khóa',
          'expired':'Hết hạn',
          'invalid':'Không hợp lệ'
        },
        'action': {
          'approve': 'Duyệt',
          'reject': 'Từ chối',
          'confirm': 'Xác nhận',
          'detail': 'Chi tiết',
          'export': 'Xuất'
        },
        'modal': {
          'approve': {
            'title': 'Phê duyệt đơn nạp tiền',
            'remark': 'Ghi chú'
          },
          'reject': {
            'title': 'Từ chối đơn nạp tiền',
            'reason': 'Lý do từ chối',
            'remark': 'Ghi chú'
          },
          'confirm': {
            'title': 'Xác nhận đơn nạp tiền',
            'content': 'Xác nhận đơn nạp tiền này đã được nhận?',
            'confirm': 'Xác nhận',
            'cancel': 'Hủy'
          }
        }
      }
    },
    'payment': {
      'title': 'Cài đặt thanh toán',
      'channel': {
        'title': 'Cài đặt kênh thanh toán',
        'name': 'Tên kênh',
        'code': 'Mã kênh',
        'type': 'Loại kênh',
        'status': 'Trạng thái',
        'config': 'Cấu hình',
        'action': {
          'add': 'Thêm kênh',
          'edit': 'Sửa kênh',
          'delete': 'Xóa kênh',
          'enable': 'Bật',
          'disable': 'Tắt'
        }
      }
    },
    // Danh sách trắng callback
    callbackWhitelist: {
      title: 'Danh sách trắng callback',
      type: {
        label: 'Loại',
        placeholder: 'Vui lòng chọn loại',
        all: 'Tất cả',
        pay: 'Thanh toán',
        withdraw: 'Rút tiền'
      },
      component: {
        label: 'Tên kênh',
        placeholder: 'Vui lòng nhập tên kênh'
      },
      ip: {
        label: 'Địa chỉ IP',
        placeholder: 'Vui lòng nhập địa chỉ IP',
        formatError: 'Vui lòng nhập định dạng địa chỉ IP hợp lệ',
        example: 'Vui lòng nhập địa chỉ IP, ví dụ: 192.168.1.1'
      },
      createTime: 'Thời gian tạo',
      createUser: 'Người tạo',
      action: {
        search: 'Tìm kiếm',
        reset: 'Đặt lại',
        add: 'Thêm IP vào danh sách trắng',
        delete: 'Xóa',
        deleteConfirm: 'Bạn có chắc chắn muốn xóa bản ghi danh sách trắng này không?',
        deleteSuccess: 'Xóa thành công',
        deleteFailed: 'Xóa thất bại',
        addSuccess: 'Thêm thành công',
        addFailed: 'Thêm thất bại'
      },
      modal: {
        addTitle: 'Thêm IP vào danh sách trắng',
        type: {
          label: 'Loại',
          placeholder: 'Vui lòng chọn loại',
          required: 'Vui lòng chọn loại'
        },
        component: {
          label: 'Lựa chọn kênh',
          placeholder: 'Vui lòng chọn kênh',
          required: 'Vui lòng chọn kênh'
        },
        ip: {
          label: 'Địa chỉ IP',
          placeholder: 'Vui lòng nhập địa chỉ IP, ví dụ: 192.168.1.1',
          required: 'Vui lòng nhập địa chỉ IP',
          formatError: 'Vui lòng nhập định dạng địa chỉ IP hợp lệ'
        },
        confirm: 'Xác nhận',
        cancel: 'Hủy'
      }
    },
    paymentSettings: {
      title: 'Cài đặt thanh toán',
      channel: {
        title: 'Kênh thanh toán',
        search: {
          channelName: 'Tên kênh',
          channelNamePlaceholder: 'Vui lòng nhập tên kênh',
          paymentGroup: 'Nhóm thanh toán',
          paymentGroupPlaceholder: 'Vui lòng chọn nhóm thanh toán',
          paymentModel: 'Phương thức thanh toán',
          paymentModelPlaceholder: 'Vui lòng chọn phương thức thanh toán',
          currency: 'Tiền tệ rút',
          currencyPlaceholder: 'Vui lòng chọn Tiền tệ rút',
          status: 'Trạng thái',
          statusPlaceholder: 'Vui lòng chọn trạng thái',
          statusEnabled: 'Bật',
          statusDisabled: 'Tắt',
          search: 'Tìm kiếm',
          button: 'Tìm kiếm',
          reset: 'Đặt lại'
        },
        table: {
          channelName: 'Tên kênh',
          paymentGroup: 'Nhóm thanh toán',
          paymentModel: 'Phương thức thanh toán',
          payDescription: 'Mô tả kênh',
          currency: 'Loại tiền tệ',
          platformType: 'Loại nền tảng',
          minAmount: 'Số tiền tối thiểu',
          maxAmount: 'Số tiền tối đa',
          amountRange:'phạm vi số lượng',
          agentOverride: 'Ghi đè đại lý',
          default: 'Mặc định',
          memberLevel:'Cấp độ thành viên',
          agentConfig: 'Cấu hình đại lý',
          agentConfigNotSet: 'Chưa cấu hình',
          agentConfigAll: 'Tất cả đại lý',
          agentConfigPartial: 'Đại lý cụ thể',
          agentConfigSet: 'Đã cấu hình',
          agentConfigOverride: 'Ghi đè đại lý · Quy tắc số tiền',
          agentConfigNote: 'Đại lý khác/người dùng thường: Sử dụng cấu hình toàn cục; Ưu tiên: Cấu hình đại lý > Cấu hình toàn cục.',
          status: 'Trạng thái',
          sort:'Sắp Xếp',
          action: 'Thao tác',
          edit: 'Sửa',
          params: 'Tham số',
          delete: 'Xóa'
        },
        modal: {
          add: 'Thêm kênh thanh toán',
          edit: 'Sửa kênh thanh toán',
          delete: {
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc chắn muốn xóa kênh thanh toán này không?'
          }
        },
        form: {
          paymentGroup: 'nhóm thanh toán',
          paymentGroupPlaceholder: 'Vui lòng chọn nhóm thanh toán',
          paymentGroupAll:'tất cả',
          paymentGroupOnline:'Thanh toán trực tuyến',
          paymentGroupOffline:'thanh toán ngoại tuyến',
          paymentModel: 'phương thức thanh toán',
          paymentModelPlaceholder: 'Vui lòng chọn phương thức thanh toán',
          channel: 'Lựa chọn kênh',
          channelPlaceholder: 'Vui lòng chọn một kênh',
          channelName:'tên kênh',
          channelNamePlaceholder:'Vui lòng nhập tên kênh',
          currency: 'loại tiền tệ',
          currencyPlaceholder: 'Vui lòng chọn loại tiền tệ',
          platformType: 'Loại nền tảng',
          platformTypePlaceholder: 'Vui lòng chọn loại nền tảng',
          paymentPlatformAll:'Tất cả',
          paymentPlatformPC:'Phía PC',
          paymentPlatformH5:'Thiết bị đầu cuối H5',
          minAmount: 'Số tiền tối thiểu',
          minAmountPlaceholder: 'Vui lòng nhập số tiền tối thiểu',
          maxAmount: 'Số tiền tối đa',
          maxAmountPlaceholder: 'Vui lòng nhập số tiền tối đa',
          depositStairs: 'Điều kiện tích lũy',
          depositStairsPlaceholder:'Vui lòng nhập các điều kiện gửi tiền tích lũy',
          amountType:'loại số tiền',
          amountTypePlaceholder:'Vui lòng chọn loại số tiền',
          amountTypeSelect:'số tiền cố định',
          amountTypeWrite:'Điền số tiền',
          amountTypeAll:'Tất cả hỗ trợ',
          amountList:'danh sách số lượng',
          amountListPlaceholder:'Vui lòng nhập danh sách số tiền, phân cách bằng dấu phẩy',
          defaultAmount: 'Số tiền mặc định',
          defaultAmountPlaceholder: 'Vui lòng nhập số tiền mặc định',
          amountListInRangeError: 'Các giá trị trong danh sách số tiền phải nằm trong khoảng từ số tiền tối thiểu đến tối đa',
          defaultAmountInListError: 'Số tiền mặc định phải được bao gồm trong danh sách số tiền khi sử dụng số tiền cố định',
          memberLevel:'Cấp độ thành viên',
          memberLevelPlaceholder:'Vui lòng chọn cấp độ thành viên',
          memberLevelAll:'tất cả các cấp độ',
          walletAccount: 'tài khoản ví',
          walletAccountPlaceholder: 'Vui lòng nhập tài khoản ví của bạn',
          walletName: 'Tên người dùng ví',
          walletNamePlaceholder: 'Vui lòng nhập tên người dùng ví của bạn',
          payTag:'Nhận xét',
          payTagPlaceholder:'Vui lòng nhập nhận xét',
          payDescription: 'Mô tả kênh',
          payDescriptionPlaceholder: 'Vui lòng nhập Mô tả kênh',
          sort:'sắp xếp',
          sortPlaceholder:'Vui lòng nhập kiểu sắp xếp',
          needMemberName:'Bạn có cần tên thật không?',
          needMemberName1:'Có',
          needMemberName2:'Không',
          usdtAccount:'Địa chỉ USDT',
          usdtAccountPlaceholder:'Vui lòng nhập địa chỉ USDT',
          usdtType:'Loại USDT',
          usdtTypePlaceholder:'Vui lòng chọn loại USDT',
          usdtRate: 'Tỷ giá hối đoái USDT',
          usdtRatePlaceholder: 'Vui lòng nhập tỷ giá hối đoái USDT',
          usdtRateType: 'Loại tỷ giá hối đoái USDT',
          usdtRateTypeFixed: 'Tỷ giá hối đoái cố định',
          usdtRateTypeFloat: 'Tỷ giá hối đoái thả nổi',
          bankName: 'Tên ngân hàng',
          bankNamePlaceholder: 'Vui lòng nhập tên ngân hàng',
          bankAccount: 'Tài khoản thẻ ngân hàng',
          bankAccountPlaceholder: 'Vui lòng nhập tài khoản thẻ ngân hàng',
          bankNumber:'số thẻ ngân hàng',
          bankNumberPlaceholder:'Vui lòng nhập số thẻ ngân hàng của bạn',
          bankAddress: 'Địa chỉ ngân hàng',
          bankAddressPlaceholder: 'Vui lòng nhập địa chỉ ngân hàng',
          accountName: 'Tên tài khoản',
          accountNamePlaceholder: 'Vui lòng nhập tên tài khoản',
          qrCode: 'Mã QR',
          qrCodeUpload: 'Tải lên mã QR',
          qrCodeTip: 'Vui lòng tải lên hình ảnh mã QR',
          agentSelect: 'Lựa chọn đại lý (Có thể tìm kiếm · Nhiều lựa chọn)',
          agentSearchPlaceholder: 'Tìm kiếm tài khoản đại lý...',
          allAgents: 'Tất cả đại lý',
          unknown: 'Không xác định',
          agentConfig: 'Cấu hình đại lý (Ghi đè số tiền toàn cục)',
          agentConfigNote: '(Thu gọn theo mặc định, chỉ cấu hình khi cần thiết)',
          agentConfigValidation: 'Xác thực: Tối thiểu ≤ Tối đa; Số tiền mặc định phải nằm trong khoảng; Khi số tiền cố định, "Số tiền mặc định" phải có trong danh sách số tiền; Các giá trị trong danh sách số tiền phải nằm trong khoảng.',
          agentConfigDisabled: 'Cấu hình đại lý đã bị tắt, vui lòng bật công tắc để cấu hình quy tắc đại lý',
          status: 'Trạng thái',
          // Thông báo xác thực cấu hình đại lý
          agentSelectRequired: 'Vui lòng chọn đại lý',
          loading: 'Đang tải...',
          noData: 'Không có dữ liệu',
          minAmountRequired: 'Số tiền tối thiểu không được để trống',
          maxAmountRequired: 'Số tiền tối đa không được để trống',
          minAmountError: 'Số tiền tối thiểu phải nhỏ hơn số tiền tối đa',
          maxAmountError: 'Số tiền tối đa phải lớn hơn số tiền tối thiểu',
          defaultAmountError: 'Số tiền mặc định phải nằm giữa số tiền tối thiểu và tối đa',
          amountListRequired: 'Danh sách số tiền là bắt buộc khi loại số tiền là cố định',
          // Thông báo chung
          missingDataId: 'Thiếu định danh dữ liệu bắt buộc, không thể cập nhật bản ghi',
          updateSuccess: 'Cập nhật thành công',
          addSuccess: 'Thêm thành công',
          updateFailed: 'Cập nhật thất bại',
          addFailed: 'Thêm thất bại',
          formValidationFailed: 'Xác thực biểu mẫu thất bại',
          formValidationFailedCheck: 'Xác thực biểu mẫu thất bại, vui lòng kiểm tra nội dung đầu vào',
          operationFailed: 'Thao tác thất bại, vui lòng thử lại',
          fetchAgentListFailed: 'Không thể tải danh sách đại lý'
        },
        param: {
          title: 'Cấu hình tham số',
          merchantId: 'ID thương nhân',
          merchantKey: 'Khóa thương nhân',
          apiUrl: 'Địa chỉ API',
          notifyUrl: 'Địa chỉ thông báo',
          remark: 'Ghi chú',
          alipayAppId: 'AppID Alipay',
          alipayPrivateKey: 'Khóa riêng Alipay',
          alipayPublicKey: 'Khóa công khai Alipay',
          wxAppId: 'AppID WeChat',
          wxMchId: 'Mã thương nhân WeChat',
          wxApiKey: 'Khóa API WeChat',
          gatewayUrl: 'Địa chỉ cổng',
          returnUrl: 'Địa chỉ trả về',
          signType: 'Loại chữ ký',
          version: 'Phiên bản',
          required: 'Vui lòng nhập thông tin bắt buộc',
          fetchError: 'Lấy danh sách tham số thất bại',
          saveSuccess: 'Lưu thành công',
          saveError: 'Lưu thất bại'
        }
      },
      method: {
        title: 'Phương thức thanh toán',
        search: {
          paymentMethodName: 'Tên phương thức thanh toán',
          paymentMethodNamePlaceholder: 'Vui lòng nhập tên phương thức thanh toán',
          curSign: 'Loại tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn loại tiền tệ',
          paymentType: 'Loại thanh toán',
          paymentTypePlaceholder: 'Vui lòng chọn loại thanh toán',
          status: 'Trạng thái',
          statusPlaceholder: 'Vui lòng chọn trạng thái',
          statusAll: 'Tất cả',
          statusEnabled: 'Bật',
          statusDisabled: 'Tắt',
          button: 'Tìm kiếm',
          reset: 'Đặt lại'
        },
        table: {
          paymentGroup: 'Nhóm thanh toán',
          paymentModel: 'Phương thức thanh toán',
          currency: 'Loại tiền tệ',
          platformType: 'Loại nền tảng',
          platformTypeAll: 'Tất cả',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          logo: 'Biểu tượng Logo',
          sort: 'Sắp xếp',
          status: 'Trạng thái',
          action: 'Thao tác',
          edit: 'Sửa',
          delete: 'Xóa'
        },
        modal: {
          add: 'Thêm phương thức thanh toán',
          edit: 'Sửa phương thức thanh toán',
          delete: {
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc chắn muốn xóa phương thức thanh toán này không?'
          },
          success: {
            create: 'Tạo thành công',
            update: 'Cập nhật thành công',
            createFailed: 'Tạo thất bại',
            updateFailed: 'Cập nhật thất bại'
          }
        },
        form: {
          basicInfo: 'Thông tin cơ bản',
          paymentGroup: 'Nhóm thanh toán',
          paymentGroupPlaceholder: 'Vui lòng chọn nhóm thanh toán',
          paymentGroupAll: 'Tất cả nhóm',
          paymentGroupOnline: 'Thanh toán trực tuyến',
          paymentGroupOffline: 'Thanh toán ngoại tuyến',
          currency: 'Tiền tệ',
          currencyPlaceholder: 'Vui lòng chọn tiền tệ',
          paymentModel: 'Phương thức thanh toán',
          paymentModelPlaceholder: 'Vui lòng chọn phương thức thanh toán',
          paymentModelName: 'Tên phương thức thanh toán',
          paymentModelNamePlaceholder: 'Vui lòng nhập tên phương thức thanh toán',
          paymentShowName:'tên hiển thị phương thức thanh toán',
          paymentShowNamePlaceholder:'Vui lòng nhập tên hiển thị phương thức thanh toán',
          payTag:'thẻ phương thức thanh toán',
          payTagPlaceholder:'Vui lòng nhập thẻ phương thức thanh toán',
          platformType: 'Loại nền tảng',
          platformTypePlaceholder: 'Vui lòng chọn loại nền tảng',
          platformTypeAll: 'Tất cả',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          sort: 'Sắp xếp',
          sortPlaceholder: 'Vui lòng nhập thứ tự sắp xếp',
          iconSettings: 'Cài đặt biểu tượng',
          pcLogo: 'Logo PC',
          h5Logo: 'Logo H5',
          otherInfo: 'Thông tin khác',
          remark: 'Ghi chú',
          remarkPlaceholder: 'Vui lòng nhập ghi chú',
          confirm: 'Xác nhận',
          cancel: 'Hủy',
          defaultPlaceholder: 'Vui lòng chọn'
        },
        error: {
          unknownType: 'Loại lựa chọn không xác định:'
        }
      }
    },
    withdrawalSettings: {
      title: 'Cài đặt rút tiền',
      withdrawalMethod: {
        title: 'Cài đặt phương thức rút tiền',
        search: {
          searchKeyword: 'Loại Tên',
          searchKeywordPlaceholder: 'Vui lòng nhập Loại Tên',
          status: 'Trạng thái',
          statusPlaceholder: 'Vui lòng chọn trạng thái',
          statusAll: 'Tất cả',
          statusEnabled: 'Bật',
          statusDisabled: 'Tắt',
          curSign: 'Loại tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn loại tiền tệ',
          button: 'Tìm kiếm',
          reset: 'Đặt lại'
        },
        table: {
          typeName: 'Loại rút tiền',
          showName: 'Tên rút tiền',
          showRemark: 'Gợi ý giao diện',
          'logoPic':'biểu tượng',
          'logoPicPC':'Phía PC',
          'logoPicH5': 'Phía H5',
          'amountRange': 'phạm vi số lượng',
          curSign: 'Tiền tệ',
          minAmount: 'Số tiền tối thiểu',
          maxAmount: 'Số tiền tối đa',
          overAmount: 'Số tiền vượt quá',
          fee: 'Phí',
          sort: 'Sắp xếp',
          status: 'Trạng thái',
          updateInfo: 'Thông tin cập nhật',
          action: 'Thao tác'
        },
        modal: {
          add: 'Thêm phương thức rút tiền',
          edit: 'Sửa phương thức rút tiền',
          delete: {
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc chắn muốn xóa phương thức rút tiền này không?'
          }
        },
        form: {
          typeName: 'Tên loại',
          typeNamePlaceholder: 'Vui lòng nhập tên loại',
          showName: 'Tên hiển thị',
          showNamePlaceholder: 'Vui lòng nhập tên hiển thị',
          showRemark: 'Ghi chú hiển thị',
          showRemarkPlaceholder: 'Vui lòng nhập ghi chú hiển thị',
          curSign: 'Loại tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn loại tiền tệ',
          minAmount: 'Số tiền tối thiểu',
          minAmountPlaceholder: 'Vui lòng nhập số tiền tối thiểu',
          maxAmount: 'Số tiền tối đa',
          maxAmountPlaceholder: 'Vui lòng nhập số tiền tối đa',
          overAmount: 'Số tiền vượt quá',
          overAmountPlaceholder: 'Vui lòng nhập số tiền vượt quá',
          fee: 'Phí',
          feePlaceholder: 'Vui lòng nhập phí',
          sort: 'Sắp xếp',
          sortPlaceholder: 'Vui lòng nhập thứ tự sắp xếp',
          pcImg: 'Biểu tượng PC',
          h5Img: 'Biểu tượng H5',
          pcImgUpload: 'Tải lên biểu tượng PC',
          h5ImgUpload: 'Tải lên biểu tượng H5',
          pcImgTip: 'Vui lòng tải lên biểu tượng PC',
          h5ImgTip: 'Vui lòng tải lên biểu tượng H5'
        },
        message: {
          addSuccess: 'Thêm thành công',
          addFailed: 'Thêm thất bại',
          editSuccess: 'Sửa thành công',
          editFailed: 'Sửa thất bại',
          deleteSuccess: 'Xóa thành công',
          deleteFailed: 'Xóa thất bại',
          enableSuccess: 'Bật thành công',
          enableFailed: 'Bật thất bại',
          disableSuccess: 'Tắt thành công',
          disableFailed: 'Tắt thất bại',
          fetchFailed: 'Lấy dữ liệu thất bại'
        },
        button: {
          edit: 'Chỉnh sửa',
          delete: 'Xóa'
        }
      },
      paidChannel: {
        title: 'Cài đặt kênh thanh toán',
        search: {
          channelName: 'Tên kênh',
          channelNamePlaceholder: 'Vui lòng nhập tên kênh',
          channelType: 'Loại kênh',
          channelTypePlaceholder: 'Vui lòng chọn loại kênh',
          curSign: 'Tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn tiền tệ',
          status: 'Trạng thái',
          statusPlaceholder: 'Vui lòng chọn trạng thái',
          statusAll: 'Tất cả',
          statusEnabled: 'Bật',
          statusDisabled: 'Tắt',
          button: 'Tìm kiếm',
          reset: 'Đặt lại'
        },
        table: {
          channelName: 'Tên kênh',
          componentName: 'Kênh thanh toán',
          channelType: 'Phương thức rút tiền',
          curSign: 'Loại tiền tệ',
          minAmount: 'Số tiền tối thiểu',
          maxAmount: 'Số tiền tối đa',
          fee: 'Phí',
          status: 'Trạng thái',
          updateInfo: 'Thông tin cập nhật',
          action: 'Thao tác'
        },
        modal: {
          add: 'Thêm kênh thanh toán',
          edit: 'Chỉnh sửa kênh thanh toán',
          delete: {
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc chắn muốn xóa kênh thanh toán này không?'
          },
          param: {
            title: 'Cấu hình tham số',
            withdrawType: 'Phương thức rút tiền',
            withdrawTypePlaceholder: 'Vui lòng chọn phương thức rút tiền',
            component: 'Thành phần',
            componentPlaceholder: 'Vui lòng chọn thành phần',
            walletAccount: 'Tài khoản ví',
            walletAccountPlaceholder: 'Vui lòng nhập tài khoản ví',
            walletName: 'Tên người dùng ví',
            walletNamePlaceholder: 'Vui lòng nhập tên người dùng ví',
            usdtRate: 'Tỷ giá USDT',
            usdtRatePlaceholder: 'Vui lòng nhập tỷ giá USDT',
            usdtRateType: 'Loại tỷ giá USDT',
            usdtRateTypeFixed: 'Tỷ giá cố định',
            usdtRateTypeFloat: 'Tỷ giá thả nổi',
            bankName: 'Tên ngân hàng',
            bankNamePlaceholder: 'Vui lòng nhập tên ngân hàng',
            bankAccount: 'Tài khoản ngân hàng',
            bankAccountPlaceholder: 'Vui lòng nhập tài khoản ngân hàng',
            bankAddress: 'Địa chỉ ngân hàng',
            bankAddressPlaceholder: 'Vui lòng nhập địa chỉ ngân hàng',
            accountName: 'Tên tài khoản',
            accountNamePlaceholder: 'Vui lòng nhập tên tài khoản',
            qrCode: 'Mã QR',
            qrCodeUpload: 'Tải lên mã QR',
            qrCodeTip: 'Vui lòng tải lên hình ảnh mã QR'
          }
        },
        form: {
          channelName: 'Tên kênh',
          channelNamePlaceholder: 'Vui lòng nhập tên kênh',
          componentName: 'Tên thành phần',
          componentNamePlaceholder: 'Vui lòng chọn thành phần',
          channelType: 'Loại kênh',
          channelTypePlaceholder: 'Vui lòng chọn loại kênh',
          curSign: 'Tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn tiền tệ',
          minAmount: 'Số tiền tối thiểu',
          minAmountPlaceholder: 'Vui lòng nhập số tiền tối thiểu',
          maxAmount: 'Số tiền tối đa',
          maxAmountPlaceholder: 'Vui lòng nhập số tiền tối đa',
          fee: 'Phí',
          feePlaceholder: 'Vui lòng nhập phí'
        },
        message: {
          fetchFailed: 'Lấy dữ liệu thất bại',
          addSuccess: 'Thêm thành công',
          addFailed: 'Thêm thất bại',
          editSuccess: 'Chỉnh sửa thành công',
          editFailed: 'Chỉnh sửa thất bại',
          deleteSuccess: 'Xóa thành công',
          deleteFailed: 'Xóa thất bại',
          enableSuccess: 'Bật thành công',
          enableFailed: 'Bật thất bại',
          disableSuccess: 'Tắt thành công',
          disableFailed: 'Tắt thất bại',
          paramSaveSuccess: 'Lưu tham số thành công',
          paramSaveFailed: 'Lưu tham số thất bại'
        },
        button: {
          add: 'Thêm',
          edit: 'Chỉnh sửa',
          delete: 'Xóa',
          param: 'Cấu hình tham số'
        }
      },
      bankSettings: {
        title: 'Cài đặt ngân hàng',
        search: {
          bankShortName: 'Tên viết tắt ngân hàng',
          bankShortNamePlaceholder: 'vd: BPI / BDO',
          bankFullName: 'Tên đầy đủ ngân hàng',
          bankFullNamePlaceholder: 'vd: Bank of the Philippine Islands',
          curSign: 'Tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn tiền tệ',
          status: 'Trạng thái',
          statusPlaceholder: 'Vui lòng chọn trạng thái',
          button: 'Tìm kiếm',
          reset: 'Đặt lại'
        },
        table: {
          bankShortName: 'Tên viết tắt ngân hàng',
          bankFullName: 'Tên đầy đủ ngân hàng',
          curSign: 'Tiền tệ',
          status: 'Trạng thái',
          action: 'Thao tác'
        },
        button: {
          add: 'Thêm',
          edit: 'Chỉnh sửa',
          delete: 'Xóa',
          channelMapping: 'Cấu hình ánh xạ kênh'
        },
        form: {
          bankShortName: 'Tên viết tắt ngân hàng',
          bankShortNamePlaceholder: 'Vui lòng nhập tên viết tắt ngân hàng',
          bankFullName: 'Tên đầy đủ ngân hàng',
          bankFullNamePlaceholder: 'Vui lòng nhập tên đầy đủ ngân hàng',
          curSign: 'Tiền tệ',
          curSignPlaceholder: 'Vui lòng chọn tiền tệ'
        },
        modal: {
          add: 'Thêm thông tin ngân hàng',
          edit: 'Chỉnh sửa thông tin ngân hàng',
          delete: {
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc chắn muốn xóa thông tin ngân hàng này không?'
          },
          channelMapping: 'Cấu hình ánh xạ kênh'
        },
        message: {
          fetchFailed: 'Lấy dữ liệu thất bại',
          createSuccess: 'Tạo thành công',
          createFailed: 'Tạo thất bại',
          updateSuccess: 'Cập nhật thành công',
          updateFailed: 'Cập nhật thất bại',
          deleteSuccess: 'Xóa thành công',
          deleteFailed: 'Xóa thất bại',
          enableSuccess: 'Kích hoạt thành công',
          enableFailed: 'Kích hoạt thất bại',
          disableSuccess: 'Vô hiệu hóa thành công',
          disableFailed: 'Vô hiệu hóa thất bại',
          operationFailed: 'Thao tác thất bại, vui lòng thử lại',
          channelMappingComingSoon: 'Tính năng cấu hình ánh xạ kênh đang được phát triển',
          fetchChannelMappingFailed: 'Không thể lấy cấu hình ánh xạ kênh',
          channelMappingSaveSuccess: 'Lưu cấu hình ánh xạ kênh thành công',
          channelMappingSaveFailed: 'Lưu cấu hình ánh xạ kênh thất bại',
          bankInfoIdRequired: 'ID thông tin ngân hàng không được để trống',
          '70023003': 'Tên viết tắt ngân hàng đã tồn tại, không thể thêm tên viết tắt ngân hàng trùng lặp',
          '70023004': 'Tên đầy đủ ngân hàng đã tồn tại, không thể thêm tên đầy đủ ngân hàng trùng lặp',
          '70023005': 'Tên ngân hàng đã tồn tại, không thể thêm tên ngân hàng trùng lặp'
        },
        channelMapping: {
          paymentChannel: 'Kênh thanh toán',
          channelName: 'Tên kênh',
          bankCode: 'Mã thanh toán (BankCode truyền cho kênh)',
          bankCodePlaceholder: 'vd: PH_AUB / 161319 / BC00007',
          notSupported: '(Không hỗ trợ kênh này)',
          description: 'Mô tả: Khi hệ thống thực hiện thanh toán, sẽ tìm mã thanh toán được cấu hình ở đây dựa trên "Tên viết tắt ngân hàng + Kênh thanh toán" và truyền cho kênh bên thứ ba. bankCode trống có nghĩa là kênh không được hỗ trợ.'
        }
      }
    },
    riskWithdrawConfig: {
      title: 'Cấu hình kiểm soát rủi ro rút tiền',
      section: {
        currencyConfig: 'Cấu hình tiền tệ'
      },
      status: {
        enabled: 'Bật',
        disabled: 'Tắt'
      },
      button: {
        save: 'Lưu'
      },
      input: {
        placeholder: 'Nhập ngưỡng'
      },
      message: {
        fetchFailed: 'Không thể tải danh sách cấu hình',
        editSuccess: 'Lưu thành công',
        editFailed: 'Lưu thất bại'
      },
      configGroup: {
        netAmount: 'Chênh lệch nạp rút (số tiền cố định)',
        netPercent: 'Chênh lệch nạp rút (phần trăm)',
        winLost: 'Thắng thua của người dùng',
        withdrawAmount: 'Số tiền rút',
        bonusPercent: 'Tỷ lệ khuyến mãi',
        bonusAmount: 'Số tiền khuyến mãi',
        riskModel: 'Chế độ kiểm soát rủi ro',
        riskRule: 'Quy tắc số tiền rút',
        bonusSection: 'Khuyến mãi',
        arbitrageSection: 'Rủi ro arbitrage game'
      },
      sectionTitle: {
        netDiff: '1) Chênh lệch nạp rút (cố định + %)',
        userWinLost: '1.2 Thắng thua (tùy chọn)',
        withdrawAmountRule: '1.3 Quy tắc số tiền rút (VIP, VIP0=Không hội viên)',
        bonus: '2) Khuyến mãi',
        arbitrage: '3) Rủi ro arbitrage (→Xem xét thủ công)',
        noDeposit: 'User 0 nạp nghi ngờ arbitrage',
        initDeposit: 'Giai đoạn nạp đầu nghi ngờ arbitrage',
        deviceIP: 'Cùng thiết bị/IP đa tài khoản nghi ngờ arbitrage'
      },
      riskRuleFields: {
        vipMin: 'VIP Min',
        vipMax: 'VIP Max',
        successWithdraw: 'Rút thành công=0',
        successWithdrawStatus: 'Trạng thái',
        successTopUp: 'Nạp thành công=0',
        successTopUpStatus: 'Trạng thái',
        successDeposit: 'Nạp thành công>0',
        successDepositStatus: 'Trạng thái',
        totalX: 'Ngưỡng X',
        totalY: 'Ngưỡng Y',
        totalZ: 'Ngưỡng Z'
      },
      arbitrageFields: {
        balance: 'Số dư',
        profitRisk: 'Tỷ lệ lợi nhuận rủi ro cao',
        deposit: 'Số tiền cược',
        historyNum: 'Số lần nạp lịch sử',
        balanceDepositMul: 'Số dư/Số tiền nạp bội số',
        depoistStart: 'Nạp từ',
        depoistEnd: 'Nạp đến',
        deviceStart: 'Thiết bị từ',
        deviceEnd: 'Thiết bị đến',
        iPStart: 'IP từ',
        iPEnd: 'IP đến'
      },
      riskModel: {
        auto: 'Tự động xem xét',
        manual: 'Xem xét thủ công'
      },
      globeStatus: {
        enabled: 'Bật',
        disabled: 'Tắt'
      },
      descriptions: {
        netAmount: 'Tổng số tiền gửi và rút chênh lệch = tổng số tiền rút - tổng số tiền gửi<br/>Tỷ lệ phần trăm chênh lệch tiền gửi và rút = tổng số tiền rút / tổng số tiền gửi * 100%<br/>Nếu số tiền gửi và rút chênh lệch của người dùng hiện tại lớn hơn giá trị đã đặt và cả hai điều kiện được đáp ứng cùng một lúc, thì sẽ vào quá trình phê duyệt thủ công',
        netPercent: 'Tổng số tiền gửi và rút chênh lệch = tổng số tiền rút - tổng số tiền gửi<br/>Tỷ lệ phần trăm chênh lệch tiền gửi và rút = tổng số tiền rút / tổng số tiền gửi * 100%<br/>Nếu số tiền gửi và rút chênh lệch của người dùng hiện tại lớn hơn giá trị đã đặt và cả hai điều kiện được đáp ứng cùng một lúc, thì sẽ vào quá trình phê duyệt thủ công',
        winLost: 'Thắng/thua của người dùng = giá trị tuyệt đối của tổng số thắng/thua tích lũy của người dùng. Nếu là số dương thì có nghĩa là người dùng có lợi nhuận.<br/>Khi số tiền thắng hoặc thua của người dùng vượt quá giá trị đã đặt, nó sẽ vào chế độ xem xét thủ công.',
        withdrawAmount: 'Khi số tiền rút = giá trị tuyệt đối của số tiền rút, nếu số tiền rút của người dùng hiện tại lớn hơn giá trị đã cài đặt, quá trình xem xét thủ công sẽ được bắt đầu.',
        bonusPercent: 'Tỷ lệ chiết khấu tổng = tổng chiết khấu nhận được / tổng số tiền gửi * 100%<br/>Tổng số tiền chiết khấu = giá trị tuyệt đối của chiết khấu nhận được<br/>Nếu giá trị tuyệt đối của tổng số tiền chiết khấu của người dùng hiện tại lớn hơn giá trị đã đặt và cả hai điều kiện được đáp ứng cùng một lúc, thì sẽ vào quá trình xem xét thủ công',
        bonusAmount: 'Tỷ lệ chiết khấu tổng = tổng chiết khấu nhận được / tổng số tiền gửi * 100%<br/>Tổng số tiền chiết khấu = giá trị tuyệt đối của chiết khấu nhận được<br/>Nếu giá trị tuyệt đối của tổng số tiền chiết khấu của người dùng hiện tại lớn hơn giá trị đã đặt và cả hai điều kiện được đáp ứng cùng một lúc, thì sẽ vào quá trình xem xét thủ công',
        riskModel: ''
      },
      addRange: 'Thêm khoảng',
      delete: 'Xóa',
      ruleHitDesc: 'Khi bất kỳ quy tắc được bật nào trúng → rút tiền vào [Xem xét thủ công].',
      hintPrefix: 'Gợi ý: ',
      autoHintDescBody: 'Đơn rút tiền trúng bất kỳ quy tắc nào bên dưới sẽ vào [Xem xét thủ công]; không thì theo quy trình tự động.',
      autoHintDesc: 'Gợi ý: Đơn rút tiền trúng bất kỳ quy tắc nào bên dưới sẽ vào [Xem xét thủ công]; không thì theo quy trình tự động.',
      balanceCalPrefix: 'Số dư rủi ro (caliber rút tiền): ',
      balanceCalBody: 'Số dư tài khoản + số tiền rút lần này + đơn rút đang xử lý + số tiền cược chưa thanh toán.',
      balanceCalDesc: 'Số dư rủi ro (caliber rút tiền): Số dư tài khoản + số tiền rút lần này + đơn rút đang xử lý + số tiền cược chưa thanh toán.',
      hitRuleTitle: '1) Quy tắc trúng rút tiền',
      tableRuleName: 'Tên quy tắc',
      tableCondition: 'Điều kiện',
      tableThreshold: 'Ngưỡng',
      tableStatus: 'Trạng thái',
      tableConfig: 'Cấu hình',
      netDiffCondition: 'Chênh lệch = tổng rút - tổng nạp ≥ ngưỡng cố định; và % chênh lệch ≥ % ngưỡng (khi cả hai bật).',
      netDiffRowName: 'Chênh lệch nạp rút (cố định / %)',
      fixedAmountLabel: 'Số tiền cố định ≥',
      percentLabel: 'Phần trăm ≥',
      winLostRowName: 'Ngưỡng thắng/thua tích lũy',
      winLostCondition: 'Thắng/thua tích lũy (hoặc ròng) đạt ngưỡng.',
      bonusRowName: 'Khuyến mãi bất thường (tỷ lệ / số tiền)',
      bonusCondition: 'Tỷ lệ khuyến mãi và tổng khuyến mãi đều ≥ ngưỡng.',
      bonusPercentLabel: 'Tỷ lệ khuyến mãi ≥',
      bonusAmountLabel: 'Số tiền khuyến mãi ≥',
      vipRangeHint: 'Khoảng: vip_min ≤ cấp VIP ≤ vip_max; không chồng chéo; tăng dần theo vip_min.',
      noHistoryWithdraw: 'Không có lịch sử rút',
      noHistoryDeposit: 'Không có lịch sử nạp',
      hasDepositRecord: 'Có lịch sử nạp',
      dailyThresholdXYZ: 'Tổng theo ngày (X/Y/Z)',
      noDepositMuted: 'Số lần nạp lịch sử=0; nếu lãi ròng âm thì không kích hoạt.',
      deviceIPMuted: 'Khoảng hỗ trợ 0-0 = không giới hạn; Y ≥ X.',
      sectionTitleNetDiffSub: '1.1 Chênh lệch nạp rút (Số tiền cố định + Phần trăm)',
      sectionTitleUserWinLostSub: '1.2 Thắng thua (Tùy chọn)',
      sectionTitleWithdrawAmountRuleSub: '1.3 Quy tắc số tiền rút (Khoảng VIP cấu hình được, VIP0=Không hội viên)',
      sectionTitleBonusSub: '2) Khuyến mãi (Quy tắc độc lập)',
      sectionTitleArbitrageSub: '3) Rủi ro arbitrage game (Trúng→Xem xét thủ công)',
      netDiffRuleDef: 'Quy tắc: <b>Chênh lệch = Tổng rút - Tổng nạp</b>; <b>% chênh lệch = (Tổng rút / Tổng nạp) × 100%</b>.<br />',
      netDiffHitLogic: 'Logic trúng: Chênh lệch của user <b>≥</b> ngưỡng; khi bật cả số tiền cố định và %, <b>cả hai phải thỏa (AND)</b> mới vào xem xét thủ công.',
      statusEnabled: 'Bật',
      statusOpen: 'Bật',
      operation: 'Thao tác',
      vipRangeIntro: 'Cấu hình theo "Khoảng cấp VIP": ',
      vipRangeIntroBold: 'vip_min=0 và vip_max=0 = không hội viên.',
      riskRuleHitDesc: 'Bất kỳ điều kiện [đã bật] trong khoảng (OR) → Xem xét thủ công.',
      vipRangeLabel: 'Khoảng cấp VIP',
      singleWithdrawThreshold: 'Ngưỡng rút đơn (X)',
      bonusRuleDef: 'Quy tắc: ',
      bonusRuleDefPart1: '<b>Tỷ lệ khuyến mãi = (Tổng khuyến mãi nhận / Tổng nạp) × 100%</b>; ',
      bonusRuleDefPart2: '<b>Tổng khuyến mãi = Giá trị tuyệt đối khuyến mãi nhận</b>.<br />',
      bonusHitLogic: 'Logic trúng: Tổng khuyến mãi (tuyệt đối) và % khuyến mãi của user đều <b>≥</b> ngưỡng; cả hai thỏa (AND) thì xem xét thủ công.',
      tableNote: 'Ghi chú',
      depositRange: 'Khoảng số lần nạp',
      deviceRange: 'Khoảng số thiết bị đăng ký',
      ipRange: 'Khoảng số IP đăng ký',
      balanceGt: 'Số dư kiểm soát rủi ro >',
      profitRiskGt: 'Tỷ lệ lợi nhuận rủi ro cao >',
      depositLt: 'Số tiền cược <',
      historyNumLt: 'Số lần nạp lịch sử <',
      balanceDepositMulGt: 'Số dư kiểm soát rủi ro/Số tiền nạp bội số >',
      saveConfig: 'Lưu cấu hình'
    }
  },
  'manualBalance': {
    'title': 'Hồ Sơ Điều Chỉnh Tài Khoản',
    'dateRange': 'Thời Gian Điều Chỉnh',
    'startDate': 'Ngày Bắt Đầu',
    'endDate': 'Ngày Kết Thúc',
    'dateRangeExceeded': 'Thời gian truy vấn không thể vượt quá {days} ngày',
    'memberAccount': 'Tài Khoản Thành Viên',
    'enterMemberAccount': 'Vui lòng nhập tài khoản thành viên',
    'transNo': 'Số Đơn Hàng',
    'enterTransNo': 'Vui lòng nhập số đơn hàng',
    'subType': 'Loại Điều Chỉnh',
    'selectSubType': 'Vui lòng chọn loại điều chỉnh',
    'manualIn': 'Nạp Tiền Thủ Công',
    'manualOut': 'Rút Tiền Thủ Công',
    'manualInNotIncludeOrder': 'Tiền gửi thủ công không bao gồm đơn hàng',
    'manualOutNotIncludeOrder': 'Rút tiền thủ công không bao gồm lệnh',
    'badDebtOrder': 'Trả Nợ Thủ Công',
    'agentIn': 'Đại Lý Nạp',
    'agentOut': 'Đại Lý Chuyển Ra',
    'curSign': 'Tiền Tệ',
    'selectCurrency': 'Vui lòng chọn tiền tệ',
    'search': 'Tìm Kiếm',
    'reset': 'Đặt Lại',
    'agentLine': 'Đại Lý',
    'unknownType': 'Loại Không Xác Định',
    'amount': 'Số Tiền Điều Chỉnh',
    'method': 'Phương Thức',
    'included': 'Đã Bao Gồm',
    'notIncluded': 'Chưa Bao Gồm',
    'remark': 'Ghi Chú',
    'beforeAmount': 'Số Dư Trước',
    'afterAmount': 'Số Dư Sau',
    'externalBetflow': 'Số Tiền Luân Chuyển',
    'createUser': 'Người Thực Hiện',
    'enterCreateUser': 'Vui lòng nhập người thực hiện',
    'export': 'Xuất',
    'exportLoading': 'Đang tạo tệp xuất, vui lòng đợi...',
    'exportSuccess': 'Nhiệm vụ xuất đã được gửi, vui lòng kiểm tra danh sách tải xuống',
    'createUserAndTime': 'Người Thực Hiện/Thời Gian',
    'totalCount': 'Tổng Số',
    'totalAmount': 'Tổng Số Tiền'
  }
};
